import React, { useCallback, useEffect } from 'react'
import { IconButton, Slide, SlideProps, Snackbar as MuiSnackbar, Alert as MuiAlert, Collapse } from '@mui/material'

import { Icon } from '../icon.tsx'

import { Alert, Unique } from './snackbar.types.ts'
import { SNACKBAR_TIMEOUT, useSnackbarContext } from './snackbar.context.ts'

const TransitionRight = (props: SlideProps): JSX.Element => <Slide {...props} direction="up" />

export const SnackItem = React.memo(
  (snack: Unique<Alert>): React.ReactElement => {
    const { hideSnack, removeHidden } = useSnackbarContext()

    useEffect(() => {
      let hideTimeout: NodeJS.Timeout
      if (snack.visible) {
        hideTimeout = setTimeout(() => {
          hideSnack(snack.id)
        }, snack.timeout)
      }
      return () => {
        clearTimeout(hideTimeout)
      }
    }, [snack.visible])

    const handleRemoveSnack = useCallback(
      (id: string) => () => {
        hideSnack(id)
      },
      [hideSnack]
    )

    return (
      <Collapse unmountOnExit in={snack.visible} timeout={SNACKBAR_TIMEOUT / 2} onExited={removeHidden}>
        <MuiSnackbar
          open={snack.visible}
          // autoHideDuration={snack.timeout ?? 3000}
          TransitionComponent={TransitionRight}
          sx={{
            '&.MuiSnackbar-root': {
              padding: '10px',
              position: 'static',
              display: 'block',
            },

            '& .MuiSnackbar-anchorOriginBottomCenter': {
              transform: 'translateX(0)',
            },
          }}
        >
          <MuiAlert
            severity={snack.severity}
            variant="filled"
            action={
              snack.closeIcon ? (
                <IconButton onClick={handleRemoveSnack(snack.id)} size="small">
                  <Icon name="Close" size="xs" />
                </IconButton>
              ) : (
                snack.action
              )
            }
          >
            {snack.message}
          </MuiAlert>
        </MuiSnackbar>
      </Collapse>
    )
  },
  (prev, next) => prev.visible === next.visible
)
